import type { CrmObject, CrmObjectsBatchResponse } from './types';

export const convertLegacyObject = (
  object: CrmObjectsBatchResponse[string]
): CrmObject =>
  ({
    objectId: object.objectId,
    objectTypeId: object.objectTypeId,
    currentUserPermissions: object.currentUserPermissions,
    properties: Object.fromEntries(
      Object.entries(object.properties).map(([key, value]) => [
        key,
        {
          name: key,
          value: value.value ?? undefined,
          sourceId: value.sourceId ?? undefined,
          source: value.source ?? undefined,
          timestamp: value.timestamp ?? undefined,
        },
      ])
    ),
  }) as CrmObject;
